const API = 'Invitations';
export const API_INVITATIONS = {
  INVITE_BALK_MEMBERS: `${API}/InviteBalkMembers`,
};
